// Detailed treatment info for the home services modal.
// Keys must match service ids in i18n.jsx -> services.list.
// Any field can be omitted; the modal falls back to "Consultar en valoración".

export const SERVICE_DETAILS = {
  // ----- Estética -----
  toxina: {
    long_description:
      "La toxina botulínica relaja los músculos responsables de las líneas dinámicas (frente, entrecejo, patas de gallo) para suavizar el rostro sin perder expresión natural. Aplicamos micro-dosis personalizadas según tu anatomía.",
    tiempo_aplicacion: "20-30 minutos",
    visibilidad_resultado: "3-7 días para efecto pleno",
    duracion_resultado: "4 a 6 meses",
    incluye: ["Valoración facial", "Marcaje personalizado", "Toxina premium importada"],
  },
  ojeras: {
    long_description:
      "Rejuvenecimiento del contorno de ojos con ácido hialurónico de baja densidad + PDRN o exosomas para corregir el surco lagrimal, hidratar la piel fina y devolverle luz a la mirada.",
    tiempo_aplicacion: "45 minutos",
    visibilidad_resultado: "Inmediato (mejora progresiva 2 semanas)",
    duracion_resultado: "12 a 18 meses",
    incluye: ["Anestesia tópica", "Hialurónico premium", "Crioterapia post-tratamiento"],
  },
  labios: {
    long_description:
      "Volumen y definición armónica con ácido hialurónico premium. Técnica natural que respeta tu proporción facial — labios hidratados, bien delineados y nada exagerados.",
    tiempo_aplicacion: "40 minutos",
    visibilidad_resultado: "Inmediato (inflamación leve 24-48h)",
    duracion_resultado: "8 a 12 meses",
    incluye: ["Anestesia", "AH premium", "Marcaje de proporciones"],
  },
  pomulos: {
    long_description:
      "Restauración del soporte facial con técnica Full Face: pómulos, mentón y línea mandibular. Levanta el rostro de forma natural sin cirugía — un lifting hialurónico.",
    tiempo_aplicacion: "60-75 minutos",
    visibilidad_resultado: "Inmediato",
    duracion_resultado: "12 a 18 meses",
    incluye: ["Diagnóstico de proporciones", "AH premium volumizador", "Seguimiento"],
  },
  rino: {
    long_description:
      "Corrección del perfil nasal sin cirugía: dorso, punta y simetría con ácido hialurónico. Cero tiempo de recuperación. Ideal para correcciones sutiles antes de considerar rinoplastia.",
    tiempo_aplicacion: "30 minutos",
    visibilidad_resultado: "Inmediato",
    duracion_resultado: "12 a 18 meses",
    incluye: ["Anestesia tópica", "AH de alta densidad", "Foto comparativa"],
  },
  hydrofacial: {
    long_description:
      "Limpieza profunda + exfoliación + hidratación + infusión de activos en una sola sesión. Tu piel queda limpia, luminosa y lista para evento — sin enrojecimiento.",
    tiempo_aplicacion: "60 minutos",
    visibilidad_resultado: "Inmediato",
    duracion_resultado: "3 a 4 semanas (se recomienda mensual)",
    incluye: ["Limpieza", "Peeling enzimático", "Mascarilla LED", "Hidratación"],
  },
  pdrn: {
    long_description:
      "Regeneración celular con polinucleótidos de salmón y exosomas. Mejora textura, firmeza y luminosidad desde el ADN. Última generación en medicina regenerativa.",
    tiempo_aplicacion: "45 minutos",
    visibilidad_resultado: "2-4 semanas (progresivo)",
    duracion_resultado: "6 meses (protocolo de 3 sesiones)",
    incluye: ["Anestesia tópica", "PDRN + Exosomas", "Crioterapia"],
  },
  hifu: {
    long_description:
      "Ultrasonido focalizado de alta intensidad que tensa la piel sin cirugía, llegando a capas profundas (SMAS). Ideal para flacidez leve a moderada en óvalo facial.",
    tiempo_aplicacion: "60-90 minutos",
    visibilidad_resultado: "3-6 meses (progresivo)",
    duracion_resultado: "12 a 18 meses",
    incluye: ["Diagnóstico", "Marcaje", "Tratamiento con HIFU médico"],
  },
  // ----- Ortodoncia -----
  brackets: {
    long_description:
      "Brackets metálicos, cerámicos o de zafiro. Tratamiento clásico, predecible y eficaz para corrección de mordida, apiñamiento y estética dental. Planes a meses sin intereses.",
    tiempo_aplicacion: "Cita inicial 90 min · controles mensuales de 30 min",
    visibilidad_resultado: "3-6 meses (cambios visibles)",
    duracion_resultado: "Tratamiento de 12 a 24 meses + retención permanente",
    incluye: ["Diagnóstico cefalométrico", "Radiografías", "Brackets", "Controles mensuales"],
  },
  invisalign: {
    long_description:
      "Alineadores transparentes removibles. Cómodos, prácticamente invisibles y removibles para comer. Mismo resultado que brackets, con discreción total.",
    tiempo_aplicacion: "Cita inicial 60 min · cambios cada 1-2 semanas",
    visibilidad_resultado: "2-4 meses (cambios visibles)",
    duracion_resultado: "Tratamiento de 6 a 24 meses según caso + retención",
    incluye: ["Escaneo 3D", "Plan virtual", "Set completo de alineadores", "Controles"],
  },
  ortopedia: {
    long_description:
      "Ortopedia funcional de los maxilares: aprovecha la etapa de crecimiento del niño para guiar el desarrollo óseo, corregir mordidas (cruzada, abierta, profunda), favorecer la armonía facial, crear espacio para los dientes permanentes y mejorar funciones como respiración, masticación y deglución. Reduce significativamente la necesidad de tratamientos más invasivos en la adolescencia o adultez.",
    tiempo_aplicacion: "Cita inicial 60 min · controles mensuales",
    visibilidad_resultado: "3-6 meses (cambios funcionales visibles)",
    duracion_resultado: "12 a 36 meses según etapa de crecimiento del niño",
    incluye: [
      "Evaluación y diagnóstico especializado",
      "Aparato funcional personalizado (Twin Block, placa removible, activador, expansor)",
      "Seguimiento integral durante todo el tratamiento",
      "Corrección de hábitos orales (succión digital, deglución atípica)",
    ],
    ideal_for: "Niños de 5 a 12 años en etapa de crecimiento",
  },
};

// Fallback defaults if a service id isn't in the map yet.
export const DEFAULT_SERVICE_DETAILS = {
  long_description: "",
  tiempo_aplicacion: "Se determina en la valoración inicial",
  visibilidad_resultado: "Variable según el plan personalizado",
  duracion_resultado: "Se calcula durante el diagnóstico",
  incluye: ["Valoración personalizada", "Plan de tratamiento", "Seguimiento profesional"],
};

// 15% discount WhatsApp text — drives users to message with the promo built-in
export function buildWhatsappLink({ serviceTitle, phone = "5217712840787" }) {
  const txt = encodeURIComponent(
    `Hola Dra. Tania, vi en su sitio web el tratamiento de *${serviceTitle}* y me interesa agendar mi primera valoración con el 15% de descuento. ¿Qué horarios tienen disponibles?`,
  );
  return `https://wa.me/${phone}?text=${txt}`;
}
